<template>
    <b-container fluid>
        <div v-bind:class="[{ busy: busy }, 'opacity-transition']">
            <pb-spinner v-if="busy"/>
            <div>
                <b-container fluid>
                    <b-row class="mb-2">
                        <b-col>
                            <b-form inline class="float-right">
                                <b-button v-b-modal.editResourceModal @click.stop="onReset" variant="primary" class="btn-sm">Add Resource
                                    <i class="mdi mdi-add usersmanagement__add-icon"></i>
                                </b-button>
                            </b-form>
                        </b-col>
                    </b-row>
                </b-container>
                <b-table responsive striped hover small
                         :fields="fields"
                         :items="resourceList">
                    <template v-slot:cell(Actions)="row" style="width: 100px;">
                        <b-button variant="link" v-b-modal.editResourceModal @click.stop="resourceToEdit = $_.cloneDeep(row.item)"><i
                            class="fal fa-edit"></i></b-button>
                        <b-button variant="link" @click="onDelete(row.item.id)">
                            <i class="fal fa-trash-alt"></i>
                        </b-button>
                    </template>
                </b-table>
            </div>

        </div>
        <b-modal id="editResourceModal" ref="editResourceModal" hide-footer>
            <form @submit.prevent="onSubmit" @reset="onReset" ref="form">
                <b-form-group label="Name:" label-for="name">
                    <b-form-input id="name" type="text" v-model="resourceToEdit.name"></b-form-input>
                </b-form-group>
                <b-form-group label="Description:" label-for="description">
                    <b-form-textarea id="description" v-model="resourceToEdit.description"></b-form-textarea>
                </b-form-group>
                <b-button type="submit" variant="primary">Submit</b-button>
                <b-button type="reset" variant="danger">Reset</b-button>
            </form>
        </b-modal>
    </b-container>
</template>

<script>
import UserResourcesApi from "@shared/_api/userResources";

export default {
    name: "registrationsTable",
    data: function () {
        return {
            fields: [
                {key: 'id', label: 'ID', sortable: true},
                {key: 'name', label: 'Name', sortable: true},
                {key: 'description', label: 'Description', sortable: true},
                {key: 'Actions', class: 'align-top table-action-column', sortable: false},
            ],
            busy: false,
            resourceList: [],
            resourceToEdit: {
                id: null,
                name: '',
                description: ''
            }
        }
    },
    mounted() {
        this.fetchAll();
    },
    methods: {
        fetchAll() {
            this.busy = true;
            UserResourcesApi.fetchAll().then(value => {
                this.resourceList = value
            }).finally(() => {
                this.busy = false;
            })
        },
        onSubmit() {
            let promise = this.resourceToEdit.id ? UserResourcesApi.update(this.resourceToEdit.id, this.resourceToEdit) : UserResourcesApi.save(this.resourceToEdit);
            promise.finally(() => {
                this.$refs.editResourceModal.hide();
                this.fetchAll();
            })
        },
        onReset() {
            this.resourceToEdit.id = null;
            this.resourceToEdit.name = '';
            this.resourceToEdit.description = '';
        },
        onDelete(resourceId) {
            UserResourcesApi.delete(resourceId).finally(() => {
                this.$refs.editResourceModal.hide();
                this.fetchAll();
            })
        }
    }
}
</script>